<template>
    <div class="purchase-item" @click="clickPurchase()">
        <div class="purchase-wrapper">
            <div class="purchase-img">
                <div class="purchase-img-wrapper">
                    <img class="img-fluid" :src="purchase.fullImageUrl" />
                </div>
            </div>
            <div class="purchase-info">
                <div class="purchase-date">{{ getRedeemedDate() }}</div>
                <div class="purchase-details">
                    {{ purchase.name }}
                </div>
                <div class="purchase-details">
                    <span>ใช้ :</span>
                    <span class="item-point">{{ getPointMessage() }}</span>
                    <span
                        >{{ lblHistory.point }}
                        <img src="@/assets/logo-cafe-history-burn.svg" alt=""
                    /></span>
                </div>
                <div class="purchase-row" v-if="type === 'draw'">
                    <span style="width: 35%">สถานะ : </span>
                    <div
                        v-if="!purchase.hasWinner"
                        v-html="purchase.privilegeMessage"
                    ></div>
                    <div
                        v-if="
                            (purchase.hasWinner === true &&
                                purchase.isWinner === true) ||
                            (purchase.hasWinner === true &&
                                purchase.isWinner === false)
                        "
                        class="purchase-txt no-icon"
                        @click="gotoAnnouncement()"
                    >
                        <u>{{ this.lblPurchase.see_name }}</u>
                    </div>
                    <!-- <div
                        v-if="
                            (purchase.hasWinner === true &&
                            purchase.isWinner === true) ||
                            (purchase.hasWinner === true &&
                            purchase.isWinner === false)
                        "
                        class="purchase-txt no-icon"
                        @click="gotoAnnouncement()"
                    >
                        {{ this.purchaseMessage }}
                    </div> -->
                    <div
                        v-if="purchase.privilegeMessage == null"
                        class="purchase-txt no-icon"
                    >
                        {{ this.lblPurchase.not_draw1 }}
                    </div>
                </div>
                <div
                    class="purchase-row"
                    v-else-if="type === 'purchase' && isActive === false"
                >
                    <span>สถานะ : </span>
                    <div class="purchase-icon"></div>
                    <div class="expired-txt" v-html="purchaseMessage"></div>
                </div>
                <div class="purchase-row" v-else-if="type === 'purchase'">
                    <span>สถานะ : </span>
                    <div class="purchase-icon"></div>
                    <div class="purchase-txt" v-html="purchaseMessage"></div>
                </div>
                <div class="purchase-row" v-else-if="type === 'interface'">
                    <span>สถานะ : </span>
                    <div v-html="purchaseMessage"></div>
                </div>
                <div class="purchase-row" v-else-if="isShowDelivery">
                    <span>สถานะ : </span>
                    <div
                        class="purchase-txt no-icon"
                        v-html="deliveryMessage"
                    ></div>
                </div>
                <div class="purchase-row" v-else-if="isShipped">
                    <span>สถานะ : </span>
                    <div class="purchase-txt no-icon">
                        {{ purchase.parcelNo }}
                    </div>
                </div>
                <div class="purchase-row" v-else-if="isShowPrivilegeMessage">
                    <span>สถานะ : </span>
                    <div
                        class="purchase-txt no-icon"
                        v-html="privilegeMessage"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
import Moment from "moment";
import Locale from "@/helper/locale/locale.js";

export default {
    name: "PurchaseItem",
    components: "",
    props: {
        lbl: Object,
        index: Number,
        purchase: Object,
    },
    data: function () {
        return {
            campaignType: Vue.CampaignType,
            deliveryMessage: "",
            isActive: false,
            isShipped: false,
            isShowAdsMessage: false,
            isShowDelivery: false,
            isShowPrivilegeMessage: true,
            isWinner: false,
            lblHistory: this.lbl.history,
            lblPurchase: this.lbl.purchase,
            privilegeMessage: this.purchase.privilegeMessage,
            purchaseMessage: "",
            type: "purchase", //draw, interface, purchase.
        };
    },
    created: function () {
        this.initialPurchase();
    },
    mounted: function () {},
    methods: {
        gotoAnnouncement() {
            this.$router.push("announcement");
        },
        //event
        clickPurchase: function () {
            if (this.isActive) {
                this.$emit("clickPurchase", this.index);
            }
        },
        //method
        initialPurchase: function () {
            if (
                this.purchase.privilegeMessageFormat &&
                this.purchase.privilegeMessageFormat.toLowerCase() === "html"
            )
                this.isShowPrivilegeMessage = false;

            //purchase message.
            switch (this.purchase.type) {
                case this.campaignType.Draw:
                    this.isDraw = true;
                    this.type = "draw";
                    this.purchaseMessage =
                        this.lblPurchase.not_draw1 +
                        (this.lblPurchase.not_draw2
                            ? " " + this.lblPurchase.not_draw2
                            : "");

                    if (this.purchase.hasWinner) {
                        this.isActive = true;
                        if (this.purchase.isWinner) {
                            this.isWinner = true;
                            this.purchaseMessage =
                                this.lblPurchase.draw_winner1 +
                                (this.lblPurchase.draw_winner2
                                    ? " " + this.lblPurchase.draw_winner2
                                    : "");

                            if (
                                this.isShowAdsMessage &&
                                this.purchase.adsMessage
                            )
                                this.purchaseMessage +=
                                    "<br />" + this.purchase.adsMessage;
                        } else {
                            this.isWinner = false;
                            this.purchaseMessage =
                                this.lblPurchase.draw_not_win1 +
                                (this.lblPurchase.draw_not_win2
                                    ? " " + this.lblPurchase.draw_not_win2
                                    : "");
                        }
                    }

                    this.isShowPrivilegeMessage = false;
                    break;
                // old type buy, free, deal logic
                case this.campaignType.Buy:
                case this.campaignType.Free:
                case this.campaignType.Deal:
                    console.log(this.purchase.serial, this.purchase.isUsed);
                    if (
                        this.purchase.isUsed &&
                        this.purchase.serial == "XXXXXXX"
                    ) {
                        this.purchaseMessage = this.lblPurchase.code_use;
                    } else if (
                        this.purchase.isUsed &&
                        this.purchase.serial != "XXXXXXX"
                    ) {
                        this.purchaseMessage = this.lblPurchase.code_use;
                    } else if (
                        !this.purchase.isUsed &&
                        this.purchase.serial != "XXXXXXX"
                    ) {
                        this.isActive = true;
                        this.purchaseMessage = this.lblPurchase.show_code;
                    } else {
                        this.purchaseMessage = this.lblPurchase.code_expired;
                    }
                    break;
                // case this.campaignType.Buy:
                // case this.campaignType.Free:
                // case this.campaignType.Deal:
                case this.campaignType.Interface:
                    this.type = "interface";
                    if (this.purchase.expireIn && this.purchase.expireIn < 0) {
                        this.purchaseMessage = this.lblPurchase.code_expired;

                        this.isShowPrivilegeMessage = false;
                    } else {
                        if (this.purchase.pointType == "get")
                            this.purchaseMessage =
                                this.lblPurchase.interface_get;
                        else
                            this.purchaseMessage =
                                this.lblPurchase.interface_use;
                    }
                    break;
            }
            //delivery.
            if (this.purchase.delivered === true) {
                this.isShowDelivery = true;
                if (this.purchase.type === this.campaignType.Draw) {
                    if (!this.purchase.hasWinner) {
                        this.isShowDelivery = false;
                    } else {
                        if (!this.purchase.isWinner)
                            this.isShowDelivery = false;
                    }
                }

                if (this.purchase.isShipped) {
                    this.isShipped = true;
                    this.deliveryMessage = this.lblPurchase.shipped;
                } else {
                    this.isShipped = false;
                    this.deliveryMessage = this.lblPurchase.delivery;
                }
            }

            this.deliveryMessage = Util.newLineToBr(this.deliveryMessage);
            this.privilegeMessage = Util.newLineToBr(this.privilegeMessage);
            this.purchaseMessage = Util.newLineToBr(this.purchaseMessage);
        },
        //utility
        getPointMessage: function () {
            // var pointType = this.purchase.pointType == 'get' ? this.lblHistory.get_point : this.lblHistory.use_point;
            var pointUnit =
                this.purchase.pointPerUnit > 1 && Locale.getLocaleCode() == 1033
                    ? "s"
                    : "";
            return this.purchase.pointPerUnit + " " + pointUnit;
        },
        getRedeemedDate: function () {
            var timestamp = this.purchase.redeemDate;
            var redeemedDate = Moment.unix(timestamp).utc();

            var thaiyear = Moment.unix(timestamp).utc().format("YYYY");
            if (Locale.getLocaleCode() === 1054) {
                thaiyear = redeemedDate.get("year") + 543;
                //for 2 digits.
                // year = thaiyear.toString().substring(2, 4);
            }

            // var monthString = this.lbl.date.month_full[
            //     redeemedDate.format("M") - 1
            // ];
            var month = redeemedDate.format("MM");
            var time = redeemedDate.format("HH:mm");
            var strDate = "";
            strDate =
                redeemedDate.format("DD") +
                " / " +
                month +
                " / " +
                thaiyear +
                " " +
                time;
            //strDate += ' - ' + redeemedDate.format('HH:mm');

            return strDate;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/_mixin.scss";

.Line-18 {
    width: 100%;
    height: 1px;
    flex-grow: 0;
    background-color: #cacaca;
}

.purchase-item {
    @extend %display-flex;
    width: 50%;
    flex: 0 0 50%;
    margin-bottom: 15px;
    padding-top: 15px;

    &:nth-child(2n - 1) {
        padding-right: 10px;
    }

    &:nth-child(2n) {
        padding-left: 10px;
    }

    @include mobile {
        width: 100%;
        flex: 0 0 100%;

        &:nth-child(2n - 1) {
            padding-right: 0;
        }

        &:nth-child(2n) {
            padding-left: 0;
        }
    }

    .purchase-wrapper {
        width: 100%;
        font-family: "PromptRegular";
        background-color: $color-light-grey-500;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;

        .purchase-date {
            color: $color-brown-700;
            font-size: 12px;
            line-height: 20px;
        }

        .purchase-details,
        .purchase-row {
            display: flex;
            align-items: center;
            font-size: 16px;
            line-height: 20px;
            padding-top: 10px;
            .item-point {
                color: $color-brown-600;
                font-family: "PromptSemiBold";
            }
            .show-modal {
                color: #6ba73c;
                font-size: 16px;
                font-family: "PromptSemiBold";
                line-height: 1.05;
                padding-top: 10px;
            }
            .purchase-txt {
                font-size: 14px;
                color: #6f6963;
                background-color: #fff;
                padding: 5px 10px;
                border-radius: 40px;
            }
            .expired-txt {
                color: #ffffff;
                font-size: 16px;
                font-weight: normal;
                font-family: "PromptRegular";
                line-height: 1.05;
            }
            span {
                margin-right: 5px;
            }
        }

        .purchase-img {
            width: 35%;
            flex: 0 0 35%;
            padding-left: 10px;
            position: relative;
            top: -20px;

            .purchase-img-wrapper {
                position: relative;
                overflow: hidden;
                width: 116px;
                height: 116px;

                img {
                    width: 116px;
                    height: 116px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    border-radius: 10px;
                }

                &:before {
                    position: relative;
                    content: "";
                    display: block;
                    padding-top: 100%;
                }
            }
        }

        .purchase-info {
            width: 60%;
            flex: 0 0 60%;
            padding: 10px;
        }
    }
}
</style>
